import React from 'react'
import Dialog from '..'
import ButtonRounded from '../../ButtonRounded'

const GenericDialog = () => (
  <div className="GenericDialog">
    <Dialog
      title="Oops. Something went wrong!"
      subtitle="Sorry, this video is temporarily unavailable right now. Please try again later."
      data-testid="generic-error-dialog"
    />
    <ButtonRounded
      theme="dark"
      text="Back"
      uppercase
      onClick={() => window.history.back()}
    />
  </div>
)

export default GenericDialog
